import { restClient } from '../../client';


export type FormSubmissionIdByPatientAndKeyInput = {
  form_key: string | 'PHQ9' | 'UPLIFT_STANDARD';
  patient_id: string;
};


export type FormSubmissionIdByPatientAndKeyOutput = {
  submission_id: string;
  completed_at: string;
};


export const formSubmissionIdByPatientAndKey = restClient.createRequest<FormSubmissionIdByPatientAndKeyInput, FormSubmissionIdByPatientAndKeyOutput>({
  url: '/api/v1/form/submission-by-key-and-patient',
  method: 'GET',
});
